<template>
  <router-view />
</template>

<script>
import request from './utils/request'

function applyAdminTheme(settings = {}) {
  const root = document.documentElement
  root.style.setProperty('--brand', settings.adminPrimaryColor || '#448154')
  root.style.setProperty('--brand-dark', settings.adminPrimaryColor || '#2a683d')
  root.style.setProperty('--accent', settings.adminAccentColor || '#EF8619')
  root.style.setProperty('--soft', settings.adminSurfaceColor || '#F5F7F5')
  root.style.setProperty('--surface', '#ffffff')
  root.style.setProperty('--page-bg', settings.adminSurfaceColor || '#F5F7F5')
}

export default {
  name: 'App',
  created() {
    this.loadTheme()
    window.addEventListener('xxst-admin-theme', this.handleThemeChange)
  },
  beforeDestroy() { window.removeEventListener('xxst-admin-theme', this.handleThemeChange) },
  methods: {
    async loadTheme() { try { applyAdminTheme(await request.get('/settings')) } catch (error) {} },
    handleThemeChange(event) { applyAdminTheme(event.detail) }
  }
}
</script>
